module.exports = __webpack_public_path__ + "static/img/brees-2013-slide-7.d197de3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2013-slide-7.jpg
// module id = aliU
// module chunks = 1